import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import APIClient from '../common/ApiClient';
import { toast } from "react-toastify";

const ResetPassword = () => {
    const location = useLocation();
    const hasRun = useRef(false);
    const [showNavigation, setShowNavigation] = useState(false);
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [emailID, setEmailID] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        processEmail();
    }, [location]);

    const processEmail = () => {
        const parts = location.pathname.split('/');
        const _email = parts[parts.length - 1];
        setEmailID(_email);
        if (bValidEmail(_email))
            setIsValidEmail(true);
        else {
            setIsValidEmail(false);
            setError(`Email ID ${_email} is not valid, please don't change the URL`);
            return '';
        }
    }

    const bValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // setError('Password has been changed!')
        if (emailID === '') return;
        APIClient.post('/resetPwd', {
            email: emailID,
            pwd: password,
            confPassword: confirmPassword
        }).then(response => {
            setError('');
            setShowNavigation(true);
            toast.success(response.data.message, {
                position: "bottom-center",
                pauseOnHover: true,
                delay: true
            });
        }).catch(error => {
            error.response.data.message ? setError(error.response.data.message) : setError(error.code + ':' + error.message);
        });
    }

    const onLogin =() => {
        window.location.href = window.location.origin + '/login';
    }

    return (
        <div className='login-container'>
            <div className="auth-form">
                <img src="/images/logo-dblue.png" alt="logo" style={{ maxWidth: '400px', width: '100%', height: 'auto', borderRadius: '5px' }} />
                <h2>Change Password</h2>
                <form onSubmit={handleSubmit}>

                    {isValidEmail && (
                        <div>
                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    )}

                    {error && <p className="error">{error}</p>}
                    {isValidEmail && <button type="submit" style={{ backgroundColor: '#002897' }}>Submit</button>}

                    {showNavigation && <p className="switch-form" onClick={onLogin}>Return to Login</p>}

                </form>
            </div>
        </div>
    );
};
export default ResetPassword;